import { RouteObject } from 'react-router-dom'
import ConvertWebp from './components/ConvertWebp'
import WafFreeReport from './components/WafFreeReport'

const ToolsModule: RouteObject = {
    path: 'tools',
    children: [
        {
            path: 'convert-webp',
            element: <ConvertWebp />,
        },
        {
            path: 'waf-free-report',
            element: <WafFreeReport />,
        },
    ],
}

export default ToolsModule
